import { createRoute } from "@tanstack/react-router";
import { Route as dashboardRoute } from "../dashboard";
import HomeView from "@/components/dashboard/HomeView";
import { $api } from "@/lib/api";

export const Route = createRoute({
  getParentRoute: () => dashboardRoute,
  path: "/",
  component: HomeView,
  loader: ({ context }) => {
    if (!localStorage.getItem("backendToken")) return;
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/home/activity"),
    );
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/meetings", {
        params: { query: { mode: "upcoming", days_ahead: 14 } },
      }),
    );
  },
});
